


























































































































































import Vue from 'vue';

import store from '@/store';
import { WorkflowStep, UserCreateStatus } from '@/store/getStarted';

import FindOrCreatePacketBranch from '@/components/getStarted/FindOrCreatePacketBranch.vue';
import FinishOrRetry from '@/components/getStarted/FinishOrRetry.vue';
import GettingStartedIsEasy from '@/components/getStarted/GettingStartedIsEasy.vue';
import GoogleClassroomCourses from '@/components/getStarted/GoogleClassroomCourses.vue';
import GroupTypeBranch from '@/components/getStarted/GroupTypeBranch.vue';
import LostUser from '@/components/getStarted/LostUser.vue';
import ManualGroupBuilder from '@/components/getStarted/ManualGroupBuilder.vue';
import NewPacketKindBranch from '@/components/getStarted/NewPacketKindBranch.vue';
import PublicPacketPicker from '@/components/getStarted/PublicPacketPicker.vue';
import Review from '@/components/getStarted/Review.vue';
import SetNameStep from '@/components/getStarted/SetNameStep.vue';
import WorkflowPacketBuilder from '@/components/getStarted/WorkflowPacketBuilder.vue';
import {
  renderSignInButton,
  SignInResponse,
  SignInText
} from '@/api/auth/google';

export default Vue.extend({
  components: {
    FindOrCreatePacketBranch,
    FinishOrRetry,
    GettingStartedIsEasy,
    GoogleClassroomCourses,
    GroupTypeBranch,
    LostUser,
    ManualGroupBuilder,
    NewPacketKindBranch,
    PublicPacketPicker,
    Review,
    SetNameStep,
    WorkflowPacketBuilder
  },

  props: {
    stepNo: {
      type: Number,
      default: 0
    },
    isPacketDetailsOpen: {
      type: Boolean,
      required: true
    },
    accountType: {
      type: String,
      required: false
    },
    magicToken: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      WorkflowStep,
      UserCreateStatus,
      email: '',
      code: '',
      codeRequested: false
    };
  },

  computed: {
    step(): WorkflowStep {
      return store.state.getStarted.step;
    },

    signingIn(): boolean {
      return store.state.getStarted.isSigningIn;
    },

    userCreateStatus(): UserCreateStatus {
      return store.state.getStarted.userCreateStatus;
    }
  },

  methods: {
    signInWithGoogle(response: SignInResponse) {
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');

      store.dispatch.getStarted.getStartedWithGoogle(response.idToken);
    },

    signInWithMicrosoft() {
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');

      store.dispatch.getStarted.getStartedWithMicrosoft();
    },

    async requestSignupCode() {
      if (!this.email) return;
      await store.dispatch.getStarted.requestEmailSignupCode(this.email);
      if (this.userCreateStatus !== UserCreateStatus.AUTH_FAILED) {
        this.codeRequested = true;
      }
    },

    async verifyEmailCode() {
      if (!this.code) return;
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');
      await store.dispatch.getStarted.getStartedWithEmailCode({
        email: this.email,
        code: this.code
      });
      if (this.userCreateStatus === UserCreateStatus.AUTH_FAILED) {
        this.code = '';
      }
    }
  },

  mounted() {
    if (this.magicToken) {
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');
      store.dispatch.getStarted.getStartedWithMagicLink(this.magicToken);
    }

    if (
      !this.magicToken ||
      this.userCreateStatus === UserCreateStatus.AUTH_FAILED
    ) {
      renderSignInButton(
        this.$refs.googleLoginButton as Element,
        SignInText.signUpWith,
        this.signInWithGoogle
      );
    }
  },

  watch: {
    // Changes to the url propagate to the store here
    stepNo: {
      immediate: true,
      handler(current) {
        if (current !== this.step) {
          // Check if we have a firebaseUser in the workflow.  If we don't, the user
          // has navigated here directly (as opposed to a forward/back in the browser)
          // and we should kick them to the start of the workflow;
          if (
            current !== WorkflowStep.SIGN_IN &&
            !store.state.getStarted.firebaseUser &&
            !store.state.getStarted.hasAccount
          ) {
            this.$router.replace({
              params: { stepNo: `${WorkflowStep.SIGN_IN}` }
            });
            return;
          }

          store.dispatch.getStarted.goToStep(current);
        }
      }
    },

    // Changes to the store propagate to route here
    step: {
      immediate: true,
      handler(current) {
        if (current !== this.stepNo) {
          this.$router.push({
            params: { stepNo: `${current}` }
          });
        }
      }
    }
  }
});
